import { SubdistrictUpdatePage } from "@/features/geolocation/page/SubdistrictUpdate";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/geolocation/subdistrict/$id/update"
)({
  component: SubdistrictUpdatePage,
});
